import type { AllowedCountry } from './types';

export const ZENDESK_SSO_BASE_URL =
  'https://qonto9015.zendesk.com/auth/v2/login/continue_with_sso_tracking' as const;

export interface SSOParams {
  authOrigin: string;
  brandId: string;
}

export const ZENDESK_SSO_PARAMS_BY_COUNTRY: Record<AllowedCountry, SSOParams> = {
  fr: {
    authOrigin: '17320677699345,true,true',
    brandId: '17320677699345',
  },
  it: {
    authOrigin: '23132128531089,true,true',
    brandId: '23132128531089',
  },
  es: {
    authOrigin: '23132160601361,true,true',
    brandId: '23132160601361',
  },
  de: {
    authOrigin: '23132188747153,true,true',
    brandId: '23132188747153',
  },
  pt: {
    authOrigin: '29853123638929,true,true',
    brandId: '29853123638929',
  },
  nl: {
    authOrigin: '29853161497105,true,true',
    brandId: '29853161497105',
  },
  be: {
    authOrigin: '29853179754385,true,true',
    brandId: '29853179754385',
  },
} as const;

export const COUNTRY_TO_HELP_CENTER_MAP = {
  fr: 'fr',
  de: 'de',
  it: 'it',
  es: 'es',
  pt: 'pt',
  at: 'de', // Austrian users mapped to German help center
  be: 'be',
  nl: 'nl',
} satisfies Record<string, AllowedCountry>;
